// removed by extract-text-webpack-plugin
module.exports = {"popwrap":"Popup-popwrap","premiumPopwrap":"Popup-premiumPopwrap","header":"Popup-header","container":"Popup-container","footer":"Popup-footer","headerTxt":"Popup-headerTxt","headerImg":"Popup-headerImg","line":"Popup-line","line3":"Popup-line3","line4":"Popup-line4","myFooter":"Popup-myFooter","continue":"Popup-continue","waits":"Popup-waits","triangle":"Popup-triangle","btnWrap":"Popup-btnWrap","mgr":"Popup-mgr","googleBtn":"Popup-googleBtn","appBtn":"Popup-appBtn","liPadding":"Popup-liPadding","txtCenter":"Popup-txtCenter","bl":"Popup-bl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/index.css
// module id = 1742
// module chunks = 0